import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export function cropYearReferenceDate(cropYear, currentDate = dayjs()) {
  const year = Number(cropYear);

  if (!Number.isInteger(year) || year < 1000 || year > 9999) {
    return currentDate;
  }

  return currentDate.year(year);
}

function parseDateValue(value, legacyFormat) {
  if (!value || typeof value !== "string") return null;

  if (legacyFormat) {
    const [day, month, year] = value.split("-");
    if (!day || !month || !year) return null;
    const parsed = dayjs(`${year}-${month}-${day}`);
    return parsed.isValid() ? parsed : null;
  }

  const parsed = dayjs(value.slice(0, 10));
  return parsed.isValid() ? parsed : null;
}

function formatDateValue(value, legacyFormat, monthOnly) {
  if (!value?.isValid()) return "";
  if (legacyFormat) return value.format(monthOnly ? "01-MM-YYYY" : "DD-MM-YYYY");
  return value.format("YYYY-MM-DD");
}

export default function CropYearDatePicker({
  cropYear,
  value,
  onChange,
  label,
  legacyFormat = false,
  monthOnly = false,
  textFieldProps = {},
  ...pickerProps
}) {
  const parsedValue = parseDateValue(value, legacyFormat);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={parsedValue}
        referenceDate={cropYearReferenceDate(cropYear)}
        views={monthOnly ? ["year", "month"] : ["year", "month", "day"]}
        openTo={monthOnly ? "month" : "day"}
        format={monthOnly ? "YYYY-MM" : "YYYY-MM-DD"}
        onChange={(nextValue) => {
          if (nextValue === null) {
            onChange("");
          } else if (nextValue.isValid()) {
            onChange(formatDateValue(nextValue, legacyFormat, monthOnly));
          }
        }}
        slotProps={{
          textField: {
            size: "small",
            ...textFieldProps,
          },
        }}
        {...pickerProps}
      />
    </LocalizationProvider>
  );
}
